import React, { useMemo } from 'react';
import moment from 'moment';
import i18n from 'i18n';
import { ReportGran } from 'core/report/ReportData';
import { DateRangePicker } from 'components/common/DateRangePicker/DateRangePicker';
import ToggleButtons from 'components/common/ToggleButtons/ToggleButtons';
import Select from 'components/common/Select/Select';
import styles from './performanceReportDimension.module.scss';
import { ReportContentModel } from '../ReportContentModel';
import { Trans } from 'react-i18next';
import { ToggleButtonField } from 'components/common/form/field/ToggleButtonField';
import { CustomField } from 'components/common/form/field/CustomField';
import { CheckboxField } from 'components/common/form/field/CheckboxField';

export const PerformanceReportDimension: React.FC<{
  model: ReportContentModel;
}> = ({ model }) => {
  function renderScheduling() {
    const endDateMoment = moment(model.state.to);
    const startDateMoment = moment(model.state.from);
    const days = endDateMoment.diff(startDateMoment, 'days');
    const hours = endDateMoment.diff(startDateMoment, 'hours');
    if (days > 0) {
      return (
        <Trans
          i18nKey='campaign.descriptions.campaignSchedulingDay'
          values={{ days: days + 1 }}
          components={{ 1: <span className='text-dark' /> }}
        />
      );
    } else if (days === 0) {
      return (
        <Trans
          i18nKey='campaign.descriptions.campaignSchedulingHour'
          values={{ hours: hours + 1 }}
          components={{ 1: <span className='text-dark' /> }}
        />
      );
    }
  }

  const reportTypes = useMemo(() => model.getReportTypes(), [model]);
  return (
    <>
      <ToggleButtonField
        label={i18n.t('report.labels.reportType')}
        name='reportType'
        value={model.state.reportType}
        options={reportTypes}
        onChange={model.updateReportType}
      />
      <CustomField label={i18n.t('report.labels.reportGran')} name='reportGran'>
        <div className={styles.reportGran}>
          <ToggleButtons
            name={'reportGran'}
            value={model.state.gran}
            options={model.reportGrans}
            onChange={model.updateGran}
          />
          <DateRangePicker
            startDate={model.state.from}
            endDate={model.state.to}
            format={
              model.state.gran === ReportGran.HOUR
                ? 'YYYY-MM-DD HH:mm:ss'
                : 'YYYY-MM-DD'
            }
            onChange={model.updateDayRange}
            showTimePicker={model.state.gran === ReportGran.HOUR}
            shortcuts={model.dateTimeShortCut()}
          />
          {model.state.dayRangeError && (
            <span className={styles.errorHint}>
              {model.state.dayRangeError}
            </span>
          )}
          <span className={styles.hint}>{renderScheduling()}</span>
          {model.isSysAdmin && model.state.gran === ReportGran.HOUR && (
            <Select
              className={styles.timezoneSelection}
              options={model.reportTimezones}
              name='reportTimezones'
              simpleValue
              value={model.state.timezone}
              onChange={model.updateTimezone}
            />
          )}
        </div>
      </CustomField>
      {model.isSysAdmin && (
        <CheckboxField
          label=''
          name='useAppsflyerConversion'
          checkboxLabel={i18n.t('report.labels.useAppsflyerConversion')}
          checked={model.state.useAppsflyerConversion}
          onChange={model.updateUseAppsflyerConversion}
        />
      )}
    </>
  );
};
